import { ChangeEvent, ReactNode } from "react";
import { TranslationKey } from "../../../../shared/i18n/i18n";
import { FieldVisibility } from "../../common/FieldVisibilityIcon";
import { AdminDetailLabel } from "./AdminDetailLabel";

type AdminTextFieldProps = {
  inputClassName?: string;
  isReadOnly: boolean;
  label: string;
  onChange?: (value: string) => void;
  t: (key: TranslationKey) => string;
  trailingAction?: ReactNode;
  value: string;
  visibility: FieldVisibility;
};

export const AdminTextField = ({
  inputClassName,
  isReadOnly,
  label,
  onChange,
  t,
  trailingAction,
  value,
  visibility,
}: AdminTextFieldProps) => {
  const handleChange = onChange
    ? (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)
    : undefined;
  const resolvedInputClassName = inputClassName ? `admin-detail-input ${inputClassName}` : "admin-detail-input";

  return (
    <label className="admin-detail-field">
      <AdminDetailLabel
        label={label}
        t={t}
        visibility={visibility}
      />
      {trailingAction ? (
        <div className="admin-detail-input-row">
          <input
            className={resolvedInputClassName}
            onChange={handleChange}
            readOnly={isReadOnly}
            type="text"
            value={value}
          />
          {trailingAction}
        </div>
      ) : (
        <input
          className={resolvedInputClassName}
          onChange={handleChange}
          readOnly={isReadOnly}
          type="text"
          value={value}
        />
      )}
    </label>
  );
};
